import styled from 'styled-components';
import { formatTime, formatFileSize } from '@utils/video/helpers';

const Panel = styled.div`
	padding: 1rem;
	background: rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.1);
	border-radius: 0.375rem;
	border: 1px solid rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.2);
`;

const PanelTitle = styled.h4`
	margin: 0 0 1rem 0;
	font-size: 1rem;
	font-weight: 600;
`;

const MetadataRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.5rem 0;

	&:not(:last-child) {
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	}
`;

const Label = styled.span`
	color: rgba(255, 255, 255, 0.7);
	font-size: 0.875rem;
`;

const Value = styled.span`
	color: #ffffff;
	font-weight: 500;
	font-size: 0.875rem;
`;

const MetadataPanel = ({ metadata }) => {
	if (!metadata) {
		return (
			<Panel>
				<PanelTitle>Video Information</PanelTitle>
				<p style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.875rem', margin: 0 }}>
					Loading video metadata...
				</p>
			</Panel>
		);
	}

	const safeDuration = Number.isFinite(metadata.duration) ? metadata.duration : 0;
	const estimatedFrames = Math.floor(safeDuration * 30); // Assuming 30fps
	const safeAspectRatio = Number.isFinite(metadata.aspectRatio)
		? metadata.aspectRatio.toFixed(2)
		: '—';

	return (
		<Panel>
			<PanelTitle>Video Information</PanelTitle>

			<MetadataRow>
				<Label>Duration:</Label>
				<Value>{formatTime(safeDuration)}</Value>
			</MetadataRow>

			<MetadataRow>
				<Label>Resolution:</Label>
				<Value>
					{metadata.width} × {metadata.height}
				</Value>
			</MetadataRow>

			<MetadataRow>
				<Label>Aspect Ratio:</Label>
				<Value>{safeAspectRatio}</Value>
			</MetadataRow>

			<MetadataRow>
				<Label>Estimated Frames:</Label>
				<Value>{estimatedFrames.toLocaleString()}</Value>
			</MetadataRow>
		</Panel>
	);
};

export default MetadataPanel;
